export const dropTargetStyle = {
  outline: "rgba(128, 128, 128, 0.7) solid 1px",
  borderRadius: "4px",
};
export const flipDurationMs = 300;
